import { IconLink, NavbarLink } from '../../../utils';

export const getMainItems = (items: Array<IconLink | NavbarLink>): Array<IconLink | NavbarLink> => {
  return items.filter((item) => 'href' in item && item.href !== '/app/admin-config' && item.href !== '/app/exports');
};

export const getSecondaryItems = (items: Array<IconLink | NavbarLink>): Array<IconLink | NavbarLink> => {
  return items.filter((item) => 'href' in item && (item.href === '/app/admin-config' || item.href === '/app/exports'));
};
